import CloseIcon from '@components/BottomSheets/CloseIcon';
import FilterBottomSheet from '@components/Filter/FilterBottomSheet';
import Text from '@components/Text';
import colors from '@constants/colors';
import ControlIcon from '@icons/Control';
import {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { createPortal } from 'react-dom';

import bottomSheetStyles from './bottomSheetStyles.module.scss';
import styles from './styles.module.scss';

const ANIMATION_DURATION_MS = 250;
const MINIMUM_INTERACTION_MS = 1;

export interface Props<S, F> {
    title: string;
    sort?: S;
    setSort?: (sort: S) => void;
    sortItems?: {value: S, label: string}[];
    filters?: F[];
    setFilters?: (filters: F[]) => void;
    filterItems?: {value: F, label: string}[];
    className?: string;
}

function Filter<S, F>(props:Props<S, F>) {
  const {
    title, sort, setSort, sortItems, filters, setFilters, filterItems, className,
  } = props;
  const filterLabel = useMemo(() => {
    if (!filterItems || !filters) return '';
    return filterItems?.filter((item) => filters.includes(item.value))?.[0]?.label;
  }, [filters, filterItems, sort]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      ref.current?.classList.remove(bottomSheetStyles.none);
      const showTimeout = setTimeout(() => {
        ref.current?.classList.remove(bottomSheetStyles.hide);
      }, MINIMUM_INTERACTION_MS);
      return () => clearTimeout(showTimeout);
    }
    ref.current?.classList.add(bottomSheetStyles.hide);
    const hideTimeout = setTimeout(() => {
      ref.current?.classList.add(bottomSheetStyles.none);
    }, ANIMATION_DURATION_MS);
    return () => clearTimeout(hideTimeout);
  }, [isOpen, ref]);
  return (
        <div className={styles.container}>
            <div onClick={() => setIsOpen(true)}
                 className={`${styles.button} ${className}`}>
                <ControlIcon color={colors.gray7} size={24}/>
            </div>
            {filterLabel && (
                <div className={styles.dot} />
            )}
            {createPortal(<div className={`${bottomSheetStyles.backdrop} ${bottomSheetStyles.none} ${bottomSheetStyles.hide}`}
                               ref={ref}>
                <div className={bottomSheetStyles.container}>
                    <header className={bottomSheetStyles.header}>
                        <Text size='lg' fontWeight='bold'>{title}</Text>
                        <CloseIcon onClick={() => setIsOpen(false)}/>
                    </header>
                    <FilterBottomSheet sort={sort}
                                       setSort={setSort}
                                       sortItems={sortItems}
                                       filters={filters}
                                       setFilters={setFilters}
                                       filterItems={filterItems} />
                </div>
            </div>, document.body)}
        </div>
  );
}

export default Filter;
